export default __webpack_public_path__ + "static/media/logo.807aa7d8.svg";